export default {
    data() {
        return {
            url: this.$serverURL + this.$api.cms.commonCmsURL,
            cmsData: {},
        }
    },
    async created() {
        document.title = "Dispo - Common CMS";
        this.getData();

    },
    methods: {
        async getData() {
            let response = await this.getCmsData(this.url);
            if (response.statusCode == 200) {
                this.cmsData = (response.data.commonCMS.length > 0) ? response.data.commonCMS[0] : {};
            }
            else {
                this.cmsData = {};
            }
        },
        async updateCms() {
            try {
                let data = {
                    'brandSectionTitle': this.cmsData.brandSectionTitle,
                    'brandSectionSubTitle': this.cmsData.brandSectionSubTitle,
                    'categorySectionTitle': this.cmsData.categorySectionTitle,
                    'popularFlowerSectionTitle': this.cmsData.popularFlowerSectionTitle,
                    'popularFlowerSectionSubTitle': this.cmsData.popularFlowerSectionSubTitle,
                    'popularFlowerSectionButtonText': this.cmsData.popularFlowerSectionButtonText,
                    'popularFlowerSectionButtonLink': this.cmsData.popularFlowerSectionButtonLink,
                    'popularVaporizersSectionTitle': this.cmsData.popularVaporizersSectionTitle,
                    'popularVaporizersSectionSubTitle': this.cmsData.popularVaporizersSectionSubTitle,
                    'popularVaporizersSectionButtonText': this.cmsData.popularVaporizersSectionButtonText,
                    'popularVaporizersSectionButtonLink': this.cmsData.popularVaporizersSectionButtonLink,
                    'todaysSpecialSectionTitle': this.cmsData.todaysSpecialSectionTitle,
                    'todaysSpecialSectionSubTitle': this.cmsData.todaysSpecialSectionSubTitle,
                    'todaysSpecialSectionButtonText': this.cmsData.todaysSpecialSectionButtonText,
                    todaysSpecialSectionShopAllButtonText: this.cmsData.todaysSpecialSectionShopAllButtonText ? this.cmsData.todaysSpecialSectionShopAllButtonText : 'Shop All Specials'
                };
                this.$swal.showLoading();
                let response = await this.createUpdateCMS(this.url, data);
                if (response.statusCode == 200 || response.statusCode == 201) {
                    
                    this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        text: response.message,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000,
                        animation: false,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                }
                await this.getData();
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            } finally {
                this.$swal.hideLoading();
            }
        }
    }
}